var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-solid:local"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_126_3216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 30,
    height: 29
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.23926 21.8379C4.82592 22.5619 3.33392 23.5619 3.33392 24.6666C3.33392 26.8759 9.30326 28.6666 16.6673 28.6666C24.0313 28.6666 30.0006 26.8759 30.0006 24.6666C30.0006 23.5619 28.5079 22.5619 26.0953 21.8379",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6673 23.3327C16.6673 23.3327 25.3339 17.6687 25.3339 11.1207C25.3339 6.45135 21.4539 2.66602 16.6673 2.66602C11.8806 2.66602 8.00061 6.45135 8.00061 11.1207C8.00061 17.6687 16.6673 23.3327 16.6673 23.3327Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.6673 14.6657C17.5513 14.6657 18.3992 14.3145 19.0243 13.6894C19.6494 13.0643 20.0006 12.2164 20.0006 11.3324C20.0006 10.4483 19.6494 9.60046 19.0243 8.97533C18.3992 8.35021 17.5513 7.99902 16.6673 7.99902C15.7832 7.99902 14.9354 8.35021 14.3102 8.97533C13.6851 9.60046 13.3339 10.4483 13.3339 11.3324C13.3339 12.2164 13.6851 13.0643 14.3102 13.6894C14.9354 14.3145 15.7832 14.6657 16.6673 14.6657Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinejoin: "round"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_126_3216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.666931 0H32.6669V32H0.666931V0Z",
    fill: "#FBBF24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation03);
export default __webpack_public_path__ + "static/media/location_03.0b72fa6e3eed2391c191b8716a025192.svg";
export { ForwardRef as ReactComponent };